<template>
  <!--  <div class="dialog_sueecss_pc">-->
  <!--    <div class="sueecss_box">-->
  <!--      <div class="dialog-close">-->
  <!--        <i class="el-icon-close" @click="() => this.$emit('closeform')"></i>-->
  <!--      </div>-->
  <!--      <img :src="retainImg" alt="" />-->
  <!--    </div>-->
  <!--  </div>-->
  <!--20240407 需求 样式更换-->
  <!-- 独立完成弹窗提示-->
  <div class="dialog-success-pc">
    <div class="success-box">
      <div class="form-box-close">
        <div class="form-box-close-icon" @click="() => this.$emit('closeform')"></div>
      </div>

      <img class="top-icon" src="https://www.esign.cn/upload/resources/image/2024/03/06/42005.png" alt="勾选icon" />

      <p class="line1">恭喜你，开通试用成功</p>
      <p class="line2">电子合同、电子签章扫码开始试用</p>
      <!--二维码-->
      <div class="form-main">
        <div class="qr-container">
          <img class="qr" src="https://www.esign.cn/upload/resources/image/2024/04/09/43148.png" alt="联系二维码" />
        </div>

        <div style="display:flex;">
          <img class="wx" src="https://www.esign.cn/upload/resources/image/2024/03/06/42015.png" alt="微信icon" />
          <span class="bottom-text">微信扫一扫</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import http from '../../../../../packages/ukey/utils/http'
export default {
  data() {
    return {
      retainImg: '',
    }
  },
  // mounted() {
  //   http({
  //     url: `${process.env.VUE_APP_WEB_URL}v1/saas-common/banners/portal_esign/home/list`,
  //     method: 'GET',
  //     headers: { 'Content-Type': 'application/json' },
  //   }).then(resData => {
  //     const { bannerList } = (resData && resData.data) || {}
  //     const bannerId =
  //       bannerList &&
  //       bannerList.map(item => {
  //         return item.bannerId
  //       })
  //     const bannerIdNum = Number(process.env.VUE_APP_LUODI_LIUZI)
  //     const index = bannerId && bannerId.indexOf(bannerIdNum)
  //     this.retainImg =
  //       resData && resData.data && resData.data.bannerList && resData.data.bannerList[index] && resData.data.bannerList[index].picUrl
  //   })
  // },
}
</script>

<style lang="less" scoped>
.dialog-success-pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 999999;
  .success-box {
    box-sizing: border-box;
    width: 460px;
    height: 470px;
    //max-width: 90%;
    //min-height: 500px;
    padding: 36px 50px;
    background: url('https://www.esign.cn/upload/resources/image/2024/03/06/42004.png') no-repeat center;
    background-size: cover;
    box-shadow: 0 4px 16px 0 rgba(8, 30, 80, 0.1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .form-box-close {
      width: 100px;
      height: 100px;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      .form-box-close-icon {
        width: 26px;
        height: 26px;
        margin: 10px 10px 0 0;
        background: url(https://www.esign.cn/images/trialDialog/icon-close.png);
        background-size: 100%;
        font-size: 28px;
        line-height: 14px;
        float: right;
        color: #999;
        cursor: pointer;
        transform: rotate(0deg);
        transition: all 0.4s ease-in-out;
        &:hover {
          transform: rotate(90deg);
        }
      }
    }

    .top-icon {
      width: 35px;
      height: 35px;
      margin: 11px 0;
    }

    .line1 {
      width: 220px;
      height: 30px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.85);
      font-size: 22px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      text-align: justify;
      white-space: nowrap;
      line-height: 30px;
      margin-left: 10px;
    }

    .line2 {
      width: 240px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.65);
      font-size: 16px;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 22px;
      margin-top: 11px;
    }

    .form-main {
      box-shadow: 0 2px 7px 0 rgba(225, 229, 237, 0.83);
      background-color: rgba(255, 255, 255, 1);
      border-radius: 16px;
      width: 198px;
      height: 211px;
      border: 1px solid rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      margin-top: 11px;
      padding-bottom: 4px;
    }

    .qr-container {
      width: 198px;
      height: 211px;
      justify-content: center;
      .qr {
        width: 164px;
        height: 164px;
        margin: 11px 0 0 17px;
      }
    }

    .wx {
      width: 13px;
      height: 11px;
      margin-top: 5px;
    }

    .bottom-text {
      width: 70px;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 20px;
      padding-left: 6px;
    }
  }
}
//.dialog_sueecss_pc {
//  position: fixed;
//  left: 0;
//  right: 0;
//  top: 0;
//  bottom: 0;
//  z-index: 10000;
//  background-color: rgba(0, 0, 0, 0.45);
//  z-index: 999999;
//}
//.dialog-close {
//  width: 100px;
//  height: 100px;
//  background: url('../../../../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
//  position: absolute;
//  top: 0;
//  right: 0;
//}
//.sueecss_box {
//  position: relative;
//  display: flex;
//  flex-direction: column;
//  align-items: center;
//  width: 460px;
//  height: 500px;
//  padding: 0 50px;
//  font-size: 14px;
//  box-shadow: 6px 6px 13px 10px rgba(2, 6, 11, 0.23);
//  background: #fff;
//  color: #666b80;
//  transform: translate(-50%, -50%);
//  left: 50%;
//  top: 50%;
//  i {
//    position: absolute;
//    top: 12px;
//    right: 14px;
//    font-size: 24px;
//    cursor: pointer;
//  }
//  img {
//    padding-top: 100px;
//    height: 460px;
//  }
//}
</style>
